(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        function reloadYotpo() {
          // 删除旧脚本
          const oldScript = document.querySelector('script[src*="staticw2.yotpo.com"]');
          if (oldScript) oldScript.remove();

          // 插入新脚本
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.async = true;
          script.src = '//staticw2.yotpo.com/LKTSDDDrzSXYPkoDFbsirhwkcpzt2cF7irpwTa1c/widget.js';
          script.onload = function() {
            console.log('✅ Yotpo widget 重新加载完成');
            if (window.yotpo?.refreshWidgets) {
              window.yotpo.refreshWidgets();
            }
          };
          document.head.appendChild(script);
        }

        // 调用刷新
        reloadYotpo();
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          var swiper = new Swiper(".alsolikeSwiper", {
         
            pagination: {
              el: ".swiper-pagination",
              type: "fraction",
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            breakpoints: {
              280: {  //当屏幕宽度大于等于320
                slidesPerView: 1.7,
                spaceBetween: 15, 
              },
              768: {  //当屏幕宽度大于等于768 
                slidesPerView: 3,
                spaceBetween: 18, 
              }, 
              1400: {  //当屏幕宽度大于等于1280
                slidesPerView: 3,
                spaceBetween: 30,
              }
            } 
          });
        }
        
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
